import React from "react";
import { Box, Grid } from "@mui/material";
import { HighlightOffRounded, ManageSearchRounded } from "@mui/icons-material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import AppButton from "common/components/Button";
import SelectOptions from "common/components/Select";
import Service from "common/utils/Common";
import { DebounceInput } from "react-debounce-input";

const SearchForm = ({
  onSubmitSearch,
  handleSearchFormInputChange,
  searchForm,
  handleClickClear,
  setSearchForm,
  builders,
  handleJobAddInputChange,
  jobAddrs,
  handleJobAddr,
}) => {
  return (
    <>
      <form noValidate onSubmit={onSubmitSearch}>
        <Grid container spacing={2}>
          <Grid container item sx={{ my: 2 }} spacing={2}>
            <Grid item xs={6} md={3} sx={{ textAlign: "right" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{}}
                  label="Date"
                  name="jobDate"
                  fullWidth
                  variant="outlined"
                  value={dayjs(searchForm.jobDate)}
                  format="YYYY-MM-DD"
                  onChange={(newVal) =>
                    setSearchForm({ ...searchForm, jobDate: newVal })
                  }
                />
              </LocalizationProvider>
            </Grid>

            {builders && (
              <Grid item xs={6} md={3}>
                <SelectOptions
                  value={
                    builders[
                      Service.getIndex(searchForm.builder.id, builders)
                    ] || ""
                  }
                  noValue={{}}
                  variant={"outlined"}
                  options={builders}
                  name="builder"
                  label="Builder Name"
                  handleFormInputChange={(e) => handleSearchFormInputChange(e)}
                ></SelectOptions>
              </Grid>
            )}
            <Grid item xs={12} md={3}>
              <DebounceInput
                className="border h-[54px] px-2 rounded-md w-full border-stone-400"
                minLength={2}
                debounceTimeout={500}
                placeholder="Job Address"
                name="jobAddress"
                value={searchForm.jobAddress}
                onChange={(e) => handleJobAddInputChange(e)}
                autoComplete="off"
              />
              {jobAddrs && jobAddrs.length > 0 && (
                <div className="bg-amber-100 border rounded-sm absolute min-w-[300px] px-1 z-10 ">
                  {jobAddrs.map((j, index) => (
                    <Box
                      key={index}
                      className="hover:bg-amber-400 cursor-pointer border p-2 relative top-0 border-t-0 border-r-0 border-l-0"
                      onClick={(e) => handleJobAddr(j)}
                    >
                      {j}
                    </Box>
                  ))}
                </div>
              )}
            </Grid>
            <Grid item xs={12} md={3}>
              <Grid container item>
                <Grid item xs={12} sx={{ mb: 1 }}>
                  <AppButton
                    icon={<ManageSearchRounded />}
                    btnValue={"Search"}
                    size={"small"}
                    isFullwidth={true}
                    variant={"contained"}
                    type="submit"
                  ></AppButton>
                </Grid>
                <Grid item xs={12}>
                  <AppButton
                    icon={<HighlightOffRounded />}
                    btnValue={"Clear"}
                    size={"small"}
                    isFullwidth={true}
                    variant={"contained"}
                    type="button"
                    handleClicked={handleClickClear}
                  ></AppButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default SearchForm;
